const i = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  11: 44,
  12: 48,
  13: 52,
  14: 56,
  15: 60,
  16: 64,
  20: 80,
  23: 92,
  24: 96,
  26: 104,
  30: 120,
  32: 128,
  34: 136,
  40: 160,
  180: 720,
  "-1,5": -6,
  "-1,25": -5,
  "-1": -4,
  "-0,75": -3,
  "-0,5": -2,
  "-0,45": -1.8,
  "-0,375": -1.5,
  "-0,3": -1.2,
  "-0,25": -1,
  "-0,2": -0.8,
  "-0,15": -0.6,
  "-0,1": -0.4,
  "0,5": 2,
  "1,5": 6,
  "2,5": 10,
  "3,5": 14,
  "4,5": 18,
  "5,5": 22,
  "6,5": 26,
  "12,5": 50,
  "16,5": 66,
  "18,5": 74,
  "20,5": 82
};
export {
  i as spacingPrimitives
};
